export default "__VITE_PUBLIC_ASSET__ddc3b263__"